/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, { useContext, useEffect, useState } from "react";

import APPLICATION_ROUTER_INTERFACE from "@DATA/Router/Interfaces/Router";
import ApplicationRouterContext from "@Contexts/Router";

import { Redirect } from "react-router-dom";


type TimeLeftProps = {
    ENDTIME: Date;
};

export const TimeLeftComponent: React.FC<TimeLeftProps> = ({
    ENDTIME
}): JSX.Element | null => {

    const ROUTER: APPLICATION_ROUTER_INTERFACE = useContext(ApplicationRouterContext);
    const QUIZROUTE = ROUTER.AUTHENTICATED.SETTINGS.SETTINGS_MY_BHP_PAGE.QUIZ;

    var timeLeft = new Date()
    timeLeft.setTime(ENDTIME.getTime() - timeLeft.getTime());

    const [date, setDate] = useState(timeLeft);

    useEffect(() => {
        let myInterval = setInterval(() => {
            setDate(new Date());
        }, 1000)
        return () => {
            clearInterval(myInterval);
        };
    });

    if (timeLeft.getTime() < 0) {
        return <Redirect to={{pathname: QUIZROUTE.QUIZFINALIZATION.URL, state: {timeExpired: true}}} />
    }

    return (
        <span className={"quiz-timeleft"}>Pozostało {('' + timeLeft.getMinutes()).padStart(2, '0')}:{('' + timeLeft.getSeconds()).padStart(2, '0')}</span>
    );
};


export default TimeLeftComponent;
